var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.753,
    height: 19.33,
    viewBox: "0 0 20.753 19.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "workers-icon",
    transform: "translate(0 -13.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518",
    transform: "translate(8.308 21.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40089",
    "data-name": "Path 40089",
    d: "M166.931,169.106a2.684,2.684,0,0,0-1.906-.783,2.622,2.622,0,0,0-1.906.783.554.554,0,0,0,.783.783,1.535,1.535,0,0,1,1.122-.444,1.647,1.647,0,0,1,1.122.444.568.568,0,0,0,.783,0A.523.523,0,0,0,166.931,169.106Z",
    transform: "translate(-162.944 -168.323)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520",
    transform: "translate(5.645 18.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40090",
    "data-name": "Path 40090",
    d: "M120.033,96.986a6.491,6.491,0,0,0-9.136,0,.554.554,0,1,0,.783.783,5.325,5.325,0,0,1,7.544,0,.82.82,0,0,0,.418.157.576.576,0,0,0,.392-.157A.523.523,0,0,0,120.033,96.986Z",
    transform: "translate(-110.72 -95.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(2.747 13.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40091",
    "data-name": "Path 40091",
    d: "M69.022,17.048a10.587,10.587,0,0,0-14.958,0,.554.554,0,0,0,.783.783,9.469,9.469,0,0,1,13.365,0,.673.673,0,0,0,.418.157.576.576,0,0,0,.392-.157A.523.523,0,0,0,69.022,17.048Z",
    transform: "translate(-53.888 -13.955)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    transform: "translate(0 24.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40092",
    "data-name": "Path 40092",
    d: "M16.55,227.2H4.229a4.229,4.229,0,0,0,0,8.458H16.524a4.229,4.229,0,0,0,.026-8.458Zm-6.709,5.9a1.671,1.671,0,1,1,1.671-1.671A1.682,1.682,0,0,1,9.841,233.1Zm5.56,0a1.671,1.671,0,1,1,1.671-1.671A1.682,1.682,0,0,1,15.4,233.1Z",
    transform: "translate(0 -227.203)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkersIcon);
export default __webpack_public_path__ + "static/media/workers-icon.ab56dfcfd7aa8aebb973eb1decdb22c3.svg";
export { ForwardRef as ReactComponent };